import { useCallback, useState } from 'react';

import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import type { AlertProps } from '@mui/material/Alert';

type Props = Omit<AlertProps, 'severity'>;

const closeLabel = 'Fermer';

// An information the user may close, its action (if any) kept beside the cross; it shows again
// once its page is opened again. An alert closed by its parent (`onClose`) keeps that behaviour.
export const InfoAlert = ({
  action,
  onClose,
  ...alertProps
}: Readonly<Props>) => {
  const [isOpen, setIsOpen] = useState(true);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!isOpen) {
    return null;
  }

  if (onClose) {
    return (
      <Alert
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...alertProps}
        action={action}
        onClose={onClose}
        severity="info"
      />
    );
  }

  const closeButton = (
    <IconButton
      aria-label={closeLabel}
      color="inherit"
      onClick={close}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Alert
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...alertProps}
      action={
        action ? (
          <>
            {action}
            {closeButton}
          </>
        ) : (
          closeButton
        )
      }
      severity="info"
    />
  );
};
